const entity_0eub3hsk = {
  redirection_on_success: "https://stockmarketedges.com/thanks",
};

export default entity_0eub3hsk;
